@if (isShowing) {
  <div class="toast-container" [class.blocking-overlay-backdrop]="options.infinite" @enterLeaveFadeAnimation>
    @if (options.onlyLoadingIndicator) {
      <div id="loading-indicator" class="toast-modal">
        <div class="spin-stretch"></div>
      </div>
    }
    @if (!options.onlyLoadingIndicator) {
      <div class="toast-modal"
        [ngClass]="{success: options.useSuccessStyle, error: options.useErrorStyle, 'align-low': options.useLowAlignStyle}" cdkTrapFocus
        [cdkTrapFocusAutoCapture]="true">
        @if (options.showCloseButton) {
          <icon name="x" class="close-icon" (click)="close()" tabindex="0" (keyup.enter)="close()" aria-label="Close">
          </icon>
        }
        @if (options.iconName) {
          <div class="icon">
            <icon [name]="options.iconName"></icon>
          </div>
        }
        <div class="content">
          @if (options.title) {
            <div class="title">{{options.title}}</div>
          }
          @if (options.message) {
            <div class="message" [innerHtml]="options.message"></div>
          }
          @if (options.isConfirmation) {
            <div class="confirm-buttons">
              <icon-button [text]="options.confirmNegativeButtonText" icon="arrow_right" class="priority" (click)="confirm(false)" cdkFocusInitial>
              </icon-button>
              <icon-button [text]="options.confirmPositiveButtonText" icon="success" class="priority" (click)="confirm(true)">
              </icon-button>
            </div>
          }
        </div>
      </div>
    }
  </div>
}